import React from 'react';
import { CheckCircle2 } from 'lucide-react';
export function MarketOpportunity() {
  const items = ['Cocheras renovadas', 'Galpones industriales', 'Talleres mecánicos', 'Locales comerciales', 'Depósitos y fábricas', 'Casas/Hogares', 'Countries'];
  return <section className="py-16 px-4 bg-[#111]" data-id="element-135">
      <div className="max-w-3xl mx-auto" data-id="element-136">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-8 text-white" data-id="element-137">
          El mercado de pisos epoxi está creciendo en Argentina
        </h2>

        <p className="text-xl text-gray-400 text-center mb-8" data-id="element-138">Cada vez más:</p>

        <div className="bg-[#1a1a1a] p-8 rounded-2xl border border-amber-900/30 shadow-sm mb-10" data-id="element-139">
          <ul className="space-y-4" data-id="element-140">
            {items.map((item, index) => <li key={index} className="flex items-center text-lg md:text-xl font-medium text-gray-200" data-id="element-141">
                <CheckCircle2 className="w-6 h-6 text-amber-500 mr-3 flex-shrink-0" data-id="element-142" />
                {item}
              </li>)}
          </ul>
        </div>

        <div className="text-center space-y-6 max-w-2xl mx-auto" data-id="element-143">
          <p className="text-xl text-gray-300 font-medium" data-id="element-144">
            El piso epoxi dejó de ser solo industrial.
          </p>
          <p className="text-xl text-gray-300 font-medium" data-id="element-145">
            Hoy es tendencia funcional, estética y resistente.
          </p>
          <p className="text-2xl font-bold text-white" data-id="element-146">La demanda crece.</p>
          <p className="text-xl text-gray-400" data-id="element-147">
            Pero hay pocos aplicadores realmente preparados.
          </p>
          <div className="bg-amber-900/20 p-4 rounded-lg border-l-4 border-amber-500" data-id="element-148">
            <p className="text-2xl font-bold text-amber-400" data-id="element-149">
              Ahí está la oportunidad.
            </p>
          </div>
        </div>

        <div className="w-full h-px bg-gray-800 mt-16" data-id="element-150"></div>
      </div>
    </section>;
}